module.exports = __webpack_public_path__ + "static/media/carousel4.5ef7e3d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/carousel4.jpg
// module id = 456
// module chunks = 16